import React from 'react';

import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';

import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import NextButton from 'components/atoms/Button/NextButton';

import PcModalBack from 'components/molecules/PcModalBack';
import PcAccordionRadioNote from 'components/molecules/PcAccordionRadioNote';
import PcAccordionRadioTextArea from 'components/molecules/PcAccordionRadioTextArea';
import PcInputItem from 'components/molecules/PcInputItem';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcPointComment from 'components/molecules/PcPointComment';
import PcInputTitle from 'components/molecules/PcInputTitle';
import PcFreeInputArea from 'components/molecules/PcFreeInputArea';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';

import { ADD_JOB_DESCRIPTION_URL, CONF_URL, POINT_COMMENT_MAP } from 'utils/constant';

const HowToDoArea = ({ howToDoAreaDisp }) => {
  return (
    <div className="mT60">
      <PcInputTitle
        title={howToDoAreaDisp.title}
        subTitle={howToDoAreaDisp.subTitle}
        label={howToDoAreaDisp.label}
        list={howToDoAreaDisp.list}
        type={howToDoAreaDisp.type}
      />
    </div>
  );
};

const AddInputArea = ({
  workInfoDips,
  bgdOfRecruitmentDisp,
}) => {
  return (
    <>
      <div className="inputArea" id="inputArea">
        <PcStepProgressBar currentStep='2' />
        <div id="workInfo" className="contents mT60">
          <div className="titleArea">
            <p className="title">募集背景・期間</p>
          </div>
          <PcPointComment labelList={POINT_COMMENT_MAP.introPointCmnt.labelList} pattern={POINT_COMMENT_MAP.introPointCmnt.pattern} />
          <div className="workInfo">
            <PcInputTitle
              title={bgdOfRecruitmentDisp.title}
              label={bgdOfRecruitmentDisp.label}
              subTitle={bgdOfRecruitmentDisp.subTitle}
              list={bgdOfRecruitmentDisp.list}
              type={bgdOfRecruitmentDisp.type}
              selectedDate={bgdOfRecruitmentDisp.selectedDate}
              comment={!bgdOfRecruitmentDisp.comment ? (<></>) : (
                <>
                  <PcFreeInputArea
                    visible={bgdOfRecruitmentDisp.comment.visible}
                    title={bgdOfRecruitmentDisp.comment.title}
                    label={bgdOfRecruitmentDisp.comment.label}
                    questionMark={bgdOfRecruitmentDisp.comment.questionMark}
                    popUpTitle={bgdOfRecruitmentDisp.comment.popUpTitle}
                    popUpDetail={bgdOfRecruitmentDisp.comment.popUpDetail}
                    relativePosArrow={bgdOfRecruitmentDisp.comment.relativePosArrow}
                    name={bgdOfRecruitmentDisp.comment.name}
                    textAreaValue={bgdOfRecruitmentDisp.comment.textAreaValue}
                    cmntOnChange={bgdOfRecruitmentDisp.comment.cmntOnChange}
                    onInput={bgdOfRecruitmentDisp.comment.onInput}
                    onCompositionEnd={bgdOfRecruitmentDisp.comment.onCompositionEnd}
                    maxLength={bgdOfRecruitmentDisp.comment.maxLength}
                    placeholder={bgdOfRecruitmentDisp.comment.placeholder}
                    rows={bgdOfRecruitmentDisp.comment.rows}
                    cols={bgdOfRecruitmentDisp.comment.cols}
                    wordCount={bgdOfRecruitmentDisp.comment.wordCount}
                    inValid={bgdOfRecruitmentDisp.comment.inValid}
                    errMessage={bgdOfRecruitmentDisp.comment.errMessage}
                  />
                </>
              )}
            />
          </div>
          <PcPointComment labelList={POINT_COMMENT_MAP.desiredStartDatePointCmnt.labelList} pattern={POINT_COMMENT_MAP.desiredStartDatePointCmnt.pattern} />
          <div className="workInfo">
            {workInfoDips.map((info) => {
              const { title, label, subTitle, list, type, comment, radioChild, selectedDate } = info;
              return (
                <span key={title}>
                  <PcInputTitle
                    title={title}
                    label={label}
                    subTitle={subTitle}
                    list={list}
                    type={type}
                    selectedDate={selectedDate}
                    comment={!comment ? (<></>) : (
                      <>
                        <PcFreeInputArea
                          visible={comment.visible}
                          title={comment.title}
                          label={comment.label}
                          questionMark={comment.questionMark}
                          popUpTitle={comment.popUpTitle}
                          popUpDetail={comment.popUpDetail}
                          relativePosArrow={comment.relativePosArrow}
                          name={comment.name}
                          textAreaValue={comment.textAreaValue}
                          cmntOnChange={comment.cmntOnChange}
                          onInput={comment.onInput}
                          onCompositionEnd={comment.onCompositionEnd}
                          maxLength={comment.maxLength}
                          placeholder={comment.placeholder}
                          rows={comment.rows}
                          cols={comment.cols}
                          wordCount={comment.wordCount}
                          inValid={comment.inValid}
                          errMessage={comment.errMessage}
                        />
                      </>
                    )}
                    radioChild={radioChild}
                  />
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

const ButtonArea = ({ workCategory, howToDo, valid, addInputValid, inputValid, onClickMainButton }) => {
  return (
    <>
      <span className="">
        {howToDo !== '02' ? (
          <>
            {workCategory === 'A' ? (
              <div className="buttonArea">
                <NextButton
                  label='次へ'
                  link={ADD_JOB_DESCRIPTION_URL}
                  valid={valid && addInputValid}
                  onClick={onClickMainButton.nextAddInput}
                />
              </div>
            ) : (
              <>
                <div className="buttonArea">
                  <NextButton
                    label='下記に同意して確認画面へ'
                    link={CONF_URL}
                    valid={valid && inputValid}
                    onClick={onClickMainButton.nextInput}
                  />
                </div>
                <div className="privacy-pollicy">
                  <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
                  ・
                  <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
                  ・
                  <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
                  {' '}
                  にご同意いただいたうえで送信してください。
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <div className="msgArea">
              <div className="msg">これより先は外部サイトに移動します。よろしければ「次へ」をクリックしてください</div>
            </div>
            <div className="buttonArea">
              <ClickOnlyButton
                label="次へ"
                color="blue"
                valid
                onClick={onClickMainButton.nextTel}
              />
            </div>
            <div className="privacy-pollicy">
              <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
              ・
              <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
              ・
              <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
              {' '}
              にご同意いただいたうえで送信してください。
            </div>
          </>
        )}
      </span>
    </>
  );
};

const PresentPC = ({
  workCategory,
  workCategoryOtherDetail,

  // 表示リスト
  WorkCategoryList,
  basicInfoList,

  // onChange
  onChangeWorkCategory,
  onChangeWorkCategoryOtherDetail,

  modalBackIsEnable,

  // onClick
  onClickMainButton,

  // 入力チェック
  valid,
  addInputValid,
  inputValid,
  errorDispMap,
  isApiError,
  showLoading,

  // 画面表示項目
  howToDo, // この後の進め方表示切替用値
  howToDoAreaDisp, // この後の進め方表示
  bgdOfRecruitmentDisp, // 募集背景
  workInfoDips, // 希望期間


}) => (
  <div className="Input PC">
    <PcBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >

      <div className='mB60'>
        <PcInputItem
          title="ご検討の職種"
          label='必須'
          questionMark
          popUpTitle="職種について"
          popUpDetail={(
            <span>
              <p>法律上の派遣禁止業務（港湾運送・建設・警備・医療・士業）や製造業務等、一部の業務は弊社のサービスの対象外となる可能性がございます。</p>
            </span>
          )}
        >
          {WorkCategoryList.dataList.map((data) => {
            if (data.value !== 'E') {
              return (
                <div className="mB10" key={data.label}>
                  <PcAccordionRadioNote
                    id={data.value}
                    value={data.value}
                    label={data.label}
                    onChange={onChangeWorkCategory}
                    checked={workCategory === data.value}

                    note={(
                      <>
                        <span className='serviceArea'>
                          <span className='area'>サービス対応エリア</span><br />
                          {WorkCategoryList.serviceArea[data.value].map((area) => {
                            return (
                              <span key={area.todofu}>
                                <span className='todofu'>{area.todofu}</span>
                                <span className=''>{area.todofuDtl}</span>
                                <br />
                              </span>
                            )
                          }
                          )}
                          <p className='remark'>※一部地域については、対応できない場合がございます</p>
                        </span>
                      </>
                    )}
                  />
                </div>
              );
            }
            if (data.value === 'E') {
              return (
                <div key={data.label}>
                  <PcAccordionRadioTextArea
                    id={data.value}
                    value={data.value}
                    label='その他　※ハイスキル派遣のご依頼はこちら'
                    RadioOnChange={onChangeWorkCategory}
                    checked={workCategory === data.value}

                    name=''
                    textAreaValue={workCategoryOtherDetail}
                    cmntOnChange={onChangeWorkCategoryOtherDetail}
                    maxLength='500'
                    placeholder=''
                    rows='10'
                    cols='30'
                    wordCount='(500文字以下)'
                    inValid={errorDispMap.workCategoryOtherDetail}
                    require='任意'
                  />
                  <span className='INPUT_ERR'>
                    <PcErrorArea position='relative' message={errorDispMap.workCategoryOtherDetail} />
                  </span>
                </div>
              );
            }
            return '';
          })}
        </PcInputItem>
      </div>


      {workCategory !== '' ? (
        <>
          {
            workCategory === 'A' ? (
              <>
                <HowToDoArea howToDoAreaDisp={howToDoAreaDisp} />
              </>
            ) : (
              <></>
            )
          }
          {
            howToDo !== '02' ? (
              <>
                {workCategory !== 'A' ? (
                  <div id='basicInfo' className='basicInfo'>
                    {basicInfoList.map((data) => {
                      return (
                        <span key={data.title}>
                          <PcInputItem
                            title={data.title}
                            subTitle={data.subTitle}
                            label={data.label}
                            questionMark={data.questionMark}
                            popUpTitle={data.popUpTitle}
                            popUpDetail={data.popUpDetail}
                          >
                            {data.input}
                          </PcInputItem>
                        </span>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    <AddInputArea
                      workInfoDips={workInfoDips}
                      bgdOfRecruitmentDisp={bgdOfRecruitmentDisp}
                    />
                  </>
                )}
              </>
            ) : (
              <></>
            )
          }
          <div className="border" />
          <ButtonArea
            workCategory={workCategory}
            howToDo={howToDo}
            valid={valid}
            addInputValid={addInputValid}
            inputValid={inputValid}
            onClickMainButton={onClickMainButton}
          />
        </>
      ) : (
        <></>
      )}
      
      <PcModalBack
        modalBackIsEnable={modalBackIsEnable}
      />

    </PcBasicTemplate>
  </div>
);

export default PresentPC;